@if (!commonDataService.isOneTime) {
    <div class="assign-block d-flex flex-row align-items-center float-start me-5" (click)="showAssigningSelect($event)">
        <div
            class="assign-block-btn form-control pointer d-flex flex-row align-items-center"
            tooltip="{{
                (assignService.isShowAssigningSelect ? null : isAssigned ? null : 'Assign this ticket to a team member')
                    | translate
            }}"
            container="body"
            placement="bottom"
            [ngClass]="{
                'assign-block-btn-edit-mode': assignService.isShowAssigningSelect,
                'field-editable': !assignService.isShowAssigningSelect,
            }">
            <div class="assign-block-image">
                <button id="lockTicketButton" class="btn btn-locked btn-icon" [hidden]="assignee">
                    <sb-inline-svg
                        class="icon"
                        aria-label="My icon"
                        [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Unlockd icon.svg'">
                    </sb-inline-svg>
                </button>
                <sb-user-avatar
                    class="user-avatar-btn"
                    [hidden]="!assignee"
                    [user]="assignee"
                    [isNeedTooltip]="false"
                    [size]="'btn'">
                </sb-user-avatar>
            </div>
            <div class="assign-block-content">
                @if (!assignService.isShowAssigningSelect) {
                    <div class="assign-block-text">
                        <div class="truncate" style="max-width: 300px; padding: 0.375rem 30px 0.375rem 0.375rem">
                            @if (assignee) {
                                @if (assignService.isAssignedToCurrentUser) {
                                    <span translate>Assigned to me</span>
                                } @else {
                                    <span> {{ 'Assigned to ' | translate }} {{ assignee.name || assignee.email }}</span>
                                }
                            } @else {
                                <span translate>Unassigned</span>
                            }
                        </div>

                        @if (isAssigned) {
                            <sb-inline-svg
                                class="icon icon-close"
                                aria-label="My icon"
                                [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/X icon.svg'"
                                (click)="unassign($event)">
                            </sb-inline-svg>
                        }
                        <!-- <button class="btn btn-icon btn-close btn-transparent">

                        </button> -->
                    </div>
                } @else {
                    <div class="assign-block-editor" (appClickOutsideAssignBlock)="closeAssigningSelect($event)">
                        <ng-select
                            [items]="usersForAssign"
                            bindLabel="label"
                            #ngSelect
                            [(ngModel)]="newAssignee"
                            placeholder="{{ 'Name or email' | translate }}"
                            (focus)="ticketListService.isTicketListActive = false"
                            (change)="updateAssignee($event); closeAssigningSelect($event)">
                            <ng-template ng-label-tmp let-item="item">
                                <div class="d-flex truncate tag-locked assign-block d-flex flex-row align-items-center">
                                    {{ item.name }}
                                </div>
                            </ng-template>
                            <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                                <div class="d-flex align-items-center mt-1 mb-1">
                                    @if (item.isSelected) {
                                        <sb-inline-svg
                                            class="icon check-icon me-2"
                                            [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Check icon.svg'">
                                        </sb-inline-svg>
                                    } @else {
                                        <sb-user-avatar
                                            class="user-avatar-btn"
                                            [user]="item"
                                            [size]="'btn'"
                                            [isNeedTooltip]="false">
                                        </sb-user-avatar>
                                    }

                                    <div class="truncate">
                                        <div class="truncate text-light">
                                            <span class="truncate-name">
                                                {{
                                                    item.name.length > 23
                                                        ? item.name.substring(0, 23) + '...'
                                                        : item.name
                                                }}
                                            </span>
                                            <small class="text-light"> {{ item.email }} </small>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                        </ng-select>
                    </div>
                }
            </div>
        </div>
    </div>
}
